import { render, staticRenderFns } from "./onlineDeposit.vue?vue&type=template&id=efd35bd4&scoped=true"
import script from "./onlineDeposit.vue?vue&type=script&lang=js"
export * from "./onlineDeposit.vue?vue&type=script&lang=js"
import style0 from "./onlineDeposit.vue?vue&type=style&index=0&id=efd35bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd35bd4",
  null
  
)

export default component.exports